export default {
  decodeIDsToMarkdownLinks(content, attachments) {
    return content.replace(/(\[\[.*?\]\])/g, item => {
      for (let i = 0; i < attachments.length; i++) {
        if (attachments[i].id === item.slice(2, item.length - 2)) {
          return ` ![](${attachments[i].public_url})`
        }
      }
      return ""
    })
  },
}
